import { State } from "..";

export function cartSelector(state: State) {
  return state.cart.data;
}
